import { useState, useEffect } from "react";
import InputField from "./InputField";
import Button from "./Button";
import { formatDatesInObject } from "../utils/formatDate";
import { Box, Typography } from "@mui/material";

const resolveFieldValue = (formData = {}, fieldId) => {
  if (!fieldId) return "";

  if (fieldId.includes(".")) {
    const [parentKey, childKey] = fieldId.split(".");
    return formData[parentKey]?.[childKey] ?? formData[childKey] ?? "";
  }

  return formData[fieldId] ?? "";
};

const DetailsSectionRenderer = ({
  sections,
  formData,
  handleBack,
  showSection = true,
  isLoading = false,
  readOnly = false,
}) => {
  const [formattedFormData, setFormattedFormData] = useState({});

  // useEffect para formatar a data
  useEffect(() => {
    if (formData && Object.keys(formData).length > 0) {
      // Chama a função utilitária que percorre o objeto e formata as datas.
      const processedData = formatDatesInObject(formData);
      setFormattedFormData(processedData);
    } else {
      setFormattedFormData({});
    }
  }, [formData]);

  if (isLoading || Object.keys(formattedFormData).length === 0) {
    return <div className="text-center py-5">Carregando detalhes...</div>;
  }

  return (
    <Box className="p-3 mt-2 rounded shadow-sm">
      {sections.map((section, index) => (
        <Box key={index}>
          <Box className="d-flex align-items-end justify-content-between">
            {showSection && (
              <Typography
                variant="h6"
                className="mb-2 text-uppercase fw-bold section-border"
                sx={{ color: "#6E707E" }}>
                {section.section}
              </Typography>
            )}
            {handleBack && index === 0 && (
              <Box className="form-row gap-2">
                <Button
                  type="button"
                  text="Voltar"
                  className="btn btn-blue-light fw-semibold"
                  onClick={handleBack}
                />
              </Box>
            )}
          </Box>
          <Box className="form-row mt-3">
            {section.fields.map((field) => {
              // O InputField converte datas ISO para DD/MM/AAAA. Passe o valor
              // original nesses campos para evitar formatar a data duas vezes.
              const value = resolveFieldValue(
                field.type === "date" ? formData : formattedFormData,
                field.id,
              );
              return (
                <Box
                  key={field.id}
                  sx={{ display: "flex", flexDirection: "column", mb: 1.5 }}
                  className={`${field.fullWidth ? "col-md-12" : "col-md-6"}`}>
                  <InputField
                    label={field.label}
                    id={field.id}
                    value={
                      value !== "" && value !== null && value !== undefined
                        ? value
                        : "-"
                    }
                    type={field.type}
                    icon={field.icon}
                    placeholder={field.placeholder}
                    readOnly={readOnly || field.readOnly}
                    disabled={field.disabled}
                  />
                </Box>
              );
            })}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default DetailsSectionRenderer;
